import { render, staticRenderFns } from "./WatchGame.vue?vue&type=template&id=030a15d4&scoped=true&lang=pug&"
import script from "./WatchGame.vue?vue&type=script&lang=ts&"
export * from "./WatchGame.vue?vue&type=script&lang=ts&"
import style0 from "./WatchGame.vue?vue&type=style&index=0&id=030a15d4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030a15d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
